<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/uniodonto/cupons">Cupons</router-link>
          </li>
          <li class="breadcrumb-item active">Criar Cupom</li>
        </ol>

        <!-- Dados usuário-->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-info-circle"></i>Informações do Cupom</h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Código</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Insira aqui o código promocional"
                  v-model="cupom.codigo"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Data de início</label>
                <date-picker
                  v-model="cupom.inicio"
                  :lang="lang"
                  placeholder="Início da Promoção"
                  format="DD/MM/YYYY"
                  value-type="format"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Data de fim</label>
                <date-picker
                  v-model="cupom.fim"
                  :lang="lang"
                  placeholder="Fim da Promoção"
                  format="DD/MM/YYYY"
                  value-type="format"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Limite Global</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Limite global"
                  v-model="cupom.limite_global"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Limite Usuário</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder="Limite por Usuário"
                  v-model="cupom.limite_usuario"
                />
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-check d-flex flex-column">
                <input class="form-check-input" @change="type='porcentagem'"  type="radio" name="exampleRadios" id="exampleRadios1" value="option1" :checked="type=='porcentagem'">
                <label class="form-check-label" for="exampleRadios1">
                  Porcentagem
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" @change="type='abs'" type="radio" name="exampleRadios" :checked="type=='abs'" id="exampleRadios2" value="option2">
                <label class="form-check-label" for="exampleRadios2">
                  Valor Absoluto
                </label>
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="type == 'porcentagem'" class="form-group">
                <label>Porcentagem</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder
                  v-model="cupom.porcentagem"
                />
              </div>
              <div v-if="type == 'abs'" class="form-group">
                <label>Valor Absoluto</label>
                <money  class="form-control" v-model="cupom.valor_absoluto" v-bind="money"></money> 
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label>Vitalício</label>
                <select
                  class="form-control"
                  v-model="cupom.vitalicio"
                >
                  <option value="1">Sim</option>
                  <option value="0">Não</option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Planos</label>
                <select
                  @change="
                    (e) => planos_selecionados.push(parseInt(e.target.value))
                  "
                  class="form-control"
                >
                  <option selected disabled>Selecione os planos</option>
                  <option
                    :value="plano.id"
                    v-for="plano in planos"
                    :key="plano.id"
                  >
                    {{ plano.name }}
                  </option>
                </select>
              </div>
              <div v-if="planos_selecionados.length > 0">
                <label>Planos Selecionados: </label>
                <div
                  class="d-flex flex-row flex-wrap mb-5 justify-content-center"
                >
                  <template v-for="plano_selecionado in planos_selecionados">
                    <span class="badge-item" :key="plano_selecionado"
                      >{{
                        planos.filter((item) => plano_selecionado == item.id)[0]
                          .name
                      }}
                      <i
                        class="fa fa-times ml-3"
                        @click="
                          planos_selecionados = planos_selecionados.filter(
                            (item) => item != plano_selecionado
                          )
                        "
                      ></i
                    ></span>
                  </template>
                </div>
              </div>
              <div v-else>
                <label>Nenhum plano selecionado. </label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>
                <button
                  href="#0"
                  class="btn_1 medium pull-right"
                  @click="criarCupom()"
                >
                  Criar
                </button>
              </p>
            </div>
          </div>
        </div>

        <!-- Dados Subscriber-->
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import {
  ajax,
  tratamento_requisicao,
  alerta,
  padronizaData,
} from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import { Loader, LoaderOptions } from "google-maps";

export default {
  components: {
    VueEditor,
    Money,
  },
  mixins: [funcoesGerais],
  data() {
    return {
      cupom: {
        vitalicio: '1'
      },
      type: "porcentagem",
      planos_selecionados: [],
      planos: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      lang: {
        days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dec",
        ],
        pickers: [
          "prox 7 dias",
          "prox 30 dias",
          "7 dias anteriores",
          "30 dias anteriores",
        ],
        placeholder: {
          date: "Selecione a data",
          dateRange: "Selecione o intervalo",
        },
      },
    };
  },
  mounted(){
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      let self = this;
      self.isLoading = true;
       ajax("get", `/operadoras/${user.id_operadora}/planos/adm`)
        .then((response) => {
          self.isLoading = false;
          this.planos = response.data;
        })
        .catch((error) => {
          self.isLoading = false;
          self.$swal.fire('Erro ao buscar planos!', '', 'error')
        });
  },
  methods: {
    date_to_timestemp(data) {
      try{
        return (
        data.split("/")[2] + "-" + data.split("/")[1] + "-" + data.split("/")[0]
      );
      }catch{
        return data
      }
      
    },
    criarCupom() {
      let self = this;
      self.isLoading = true;
      let cupom = { ...this.cupom };
      if(this.type == "porcentagem"){
        cupom.valor_absoluto = 0
      }else{
        cupom.porcentagem = 0
        cupom.valor_absoluto = cupom.valor_absoluto * 100
      }
      if(cupom.inicio){
         cupom.inicio = this.date_to_timestemp(cupom.inicio);
      }
      if(cupom.fim){
        cupom.fim = this.date_to_timestemp(cupom.fim);
      }
      cupom.planos = [...this.planos_selecionados]
      if(cupom.fim > cupom.inicio){
           ajax("post", "cupons", cupom)
        .then((response) => {
          self.isLoading = false;
          self.$swal.fire('Cupom criado com sucesso!', '', 'success')
          this.$router.push({path: '/uniodonto/cupons'})
        })
        .catch((error) => {
          self.isLoading = false;
          self.$swal.fire('Erro ao criar cupom!', '', 'error')
        });
      }else{
        self.isLoading = false;
        self.$swal.fire("A data de fim precisa ser maior que a data de inicio!", "", "error");
      }
     
    },
  },
};
</script>

<style scoped>
.input-horario {
  width: 50px;
  border: blue;
}

#map {
  width: 100%;
}

.badge-item{
    padding: 5px;
    background-color: #af104c;
    color: white;
    border-radius: 3px;
    box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.100);
    margin: 3px;
    flex: none !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 3px #860939;

}
</style>